"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _panameraReactUi = require("@olxid/panamera-react-ui");
var _classnames = _interopRequireDefault(require("classnames"));
var _KycPopupConfig = _interopRequireDefault(require("./KycPopupConfig"));
var _images = require("../../Helpers/images");
var _imageUrls = require("../../Helpers/imageUrls");
var _kycReplyRestriction = require("../../Constants/kycReplyRestriction");
var _kycRestrictionHelper = require("../../Helpers/kycRestrictionHelper");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var css = {
  "kycPopup": "ragnarok-3suPa",
  "modalConfig": "ragnarok-3Bedj"
};
var UserKycPopup = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(UserKycPopup, _React$PureComponent);
  function UserKycPopup() {
    var _this;
    (0, _classCallCheck2.default)(this, UserKycPopup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserKycPopup, [].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getFlowType", function () {
      var isKycSoftBreach = _this.props.isKycSoftBreach;
      if (isKycSoftBreach) {
        return _kycReplyRestriction.TRACKING_FLOW.LOW_THRESHOLD;
      }
      return _kycReplyRestriction.TRACKING_FLOW.HIGH_THRESHOLD;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "track", function (name, params) {
      var _this$props = _this.props,
        item_id = _this$props.item_id,
        buyer_id = _this$props.buyer_id,
        seller_id = _this$props.seller_id,
        conversationCountLeft = _this$props.conversationCountLeft;
      var finalParams = _objectSpread({
        origin: _kycReplyRestriction.RESTRICTION_TEXT,
        flow_type: _this.getFlowType(),
        select_from: (0, _kycRestrictionHelper.getKYCPopupSource)(_this.props.customRouter.location),
        result_count: conversationCountLeft,
        item_id: item_id,
        buyer_id: buyer_id,
        seller_id: seller_id
      }, params);
      _this.props.track(name, finalParams);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mainCtaHandler", function () {
      _this.track(_kycReplyRestriction.TRACKING_NAME.KYC_POP_UP_CLICK, {
        chosen_option: _kycReplyRestriction.TRACKING_PARAMS.CONT_TO_CHAT
      });
      _this.props.continueToChatTapped('CTA_CLICKED');
      _this.props.customRouter.goBack();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getKycPopupData", function () {
      var _this$props2 = _this.props,
        isSeller = _this$props2.isSeller,
        isKycSoftBreach = _this$props2.isKycSoftBreach,
        conversationCountLeft = _this$props2.conversationCountLeft,
        ImageWrapper = _this$props2.ImageWrapper,
        isMakeOfferTapped = _this$props2.isMakeOfferTapped;
      var kycCountLeft = {
        kycCountLeft: conversationCountLeft
      };
      if (isSeller && isKycSoftBreach) {
        return {
          heading: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
            id: _kycReplyRestriction.CTA_IDS.COMPLETE_KYC_TEXT
          }),
          detailText: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
            id: _kycReplyRestriction.CTA_IDS.SELLER_KYC_COUNT_LEFT,
            values: kycCountLeft
          }),
          helperText: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
            id: _kycReplyRestriction.CTA_IDS.SELLER_CAPTION
          }),
          cta: {
            text: isMakeOfferTapped ? (0, _jsx2.default)(_reactIntl.FormattedMessage, {
              id: _kycReplyRestriction.CTA_IDS.MAKE_AN_OFFER
            }) : (0, _jsx2.default)(_reactIntl.FormattedMessage, {
              id: _kycReplyRestriction.CTA_IDS.CONTINUE_TO_CHAT
            }),
            handler: _this.mainCtaHandler,
            type: _kycReplyRestriction.CTA_IDS.TYPE_PRIMARY,
            id: 'continueBtnKyc',
            css: 'kycContinueToChat'
          },
          icon: ImageWrapper && (0, _jsx2.default)(ImageWrapper, {
            fileName: _imageUrls.fileNames.KYC_RECOMMENDED,
            types: _images.WEBP_TYPE,
            width: "200",
            height: "133"
          })
        };
      } else if (isSeller) {
        return {
          heading: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
            id: _kycReplyRestriction.CTA_IDS.CHAT_LIMIT_OVER
          }),
          detailText: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
            id: _kycReplyRestriction.CTA_IDS.KYC_LIMIT_BREACH_TXT
          }),
          icon: ImageWrapper && (0, _jsx2.default)(ImageWrapper, {
            fileName: _imageUrls.fileNames.KYC_BLOCKED,
            types: _images.WEBP_TYPE,
            height: "153",
            width: "109"
          })
        };
      } else if (isKycSoftBreach) {
        return {
          heading: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
            id: _kycReplyRestriction.CTA_IDS.COMPLETE_KYC_TEXT
          }),
          detailText: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
            id: _kycReplyRestriction.CTA_IDS.KYC_COUNT_LEFT,
            values: kycCountLeft
          }),
          cta: {
            text: isMakeOfferTapped ? (0, _jsx2.default)(_reactIntl.FormattedMessage, {
              id: _kycReplyRestriction.CTA_IDS.MAKE_AN_OFFER
            }) : (0, _jsx2.default)(_reactIntl.FormattedMessage, {
              id: _kycReplyRestriction.CTA_IDS.CONTINUE_TO_CHAT
            }),
            handler: _this.mainCtaHandler,
            type: _kycReplyRestriction.CTA_IDS.TYPE_PRIMARY,
            id: 'continueBtnKyc',
            css: 'kycContinueToChat'
          },
          icon: ImageWrapper && (0, _jsx2.default)(ImageWrapper, {
            fileName: _imageUrls.fileNames.KYC_RECOMMENDED,
            types: _images.WEBP_TYPE,
            width: "200",
            height: "133"
          })
        };
      }
      return {
        heading: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
          id: _kycReplyRestriction.CTA_IDS.COMPLETE_KYC_TEXT
        }),
        detailText: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
          id: _kycReplyRestriction.CTA_IDS.KYC_LIMIT_BREACH_TXT
        }),
        icon: ImageWrapper && (0, _jsx2.default)(ImageWrapper, {
          fileName: _imageUrls.fileNames.KYC_BLOCKED,
          types: _images.WEBP_TYPE,
          height: "153",
          width: "109"
        })
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderKYCModal", function () {
      var kycPopupData = _this.getKycPopupData();
      return (0, _jsx2.default)(_KycPopupConfig.default, {
        kycPopupData: kycPopupData
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onOverlayClick", function (e) {
      e.preventDefault();
      _this.track(_kycReplyRestriction.TRACKING_NAME.KYC_POP_UP_CLICK, {
        chosen_option: _kycReplyRestriction.TRACKING_PARAMS.DISMISS_POPUP
      });
      _this.props.continueToChatTapped();
      _this.props.customRouter.goBack();
    });
    return _this;
  }
  (0, _createClass2.default)(UserKycPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.track(_kycReplyRestriction.TRACKING_NAME.KYC_POP_SHOW);
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _jsx2.default)(_panameraReactUi.Modal, {
        onClick: this.onOverlayClick,
        icon: 'cross',
        className: (0, _classnames.default)("".concat(css.kycPopup, " ").concat(css.modalConfig))
      }, void 0, this.renderKYCModal());
    }
  }]);
  return UserKycPopup;
}(_react.default.PureComponent);
(0, _defineProperty2.default)(UserKycPopup, "propTypes", {
  isKycSoftBreach: _propTypes.default.bool,
  conversationCountLeft: _propTypes.default.number,
  customRouter: _propTypes.default.object,
  item_id: _propTypes.default.string,
  buyer_id: _propTypes.default.string,
  track: _propTypes.default.func,
  continueToChatTapped: _propTypes.default.func,
  ImageWrapper: _propTypes.default.object,
  isMakeOfferTapped: _propTypes.default.object,
  isSeller: _propTypes.default.bool,
  seller_id: _propTypes.default.string
});
(0, _defineProperty2.default)(UserKycPopup, "defaultProps", {
  isKycSoftBreach: false,
  conversationCountLeft: 0,
  track: function track() {},
  continueToChatTapped: function continueToChatTapped() {}
});
var _default = exports.default = UserKycPopup;